const currency = (value) => {
  if (value && !isNaN(parseFloat(value)) && isFinite(value)) {
    return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })
  } else {
    return value
  }
}

export default currency
